import { apiClient } from "@/lib/api-client";
import type {
	CommentDto,
	CommentSubjectRef,
	CreateCommentInput,
} from "./types";

export class CommentsApiClient {
	async list(ref: CommentSubjectRef): Promise<CommentDto[]> {
		const response = await apiClient.get(
			`/api/v1/comments/${ref.subjectType}/${ref.subjectId}`,
		);
		return response.data.data.comments ?? [];
	}

	async create(
		ref: CommentSubjectRef,
		payload: CreateCommentInput,
	): Promise<{ success: boolean; comment?: CommentDto; error?: string }> {
		try {
			const response = await apiClient.post(
				`/api/v1/comments/${ref.subjectType}/${ref.subjectId}`,
				payload,
			);
			return { success: true, comment: response.data.data.comment };
		} catch (error: unknown) {
			const err = error as { response?: { data?: { message?: string } } };
			return {
				success: false,
				error: err.response?.data?.message || "Failed to create comment",
			};
		}
	}
}
